import { getSupabaseClient } from '../../lib/supabase'
import type { Database } from '../../types/database.generated'

export type Notification = Database['public']['Tables']['notifications']['Row']
export type NotificationPreferences = Database['public']['Tables']['notification_preferences']['Row']
export type DigestFrequency = Database['public']['Enums']['notification_digest_frequency']
export type OnboardingProgress = Database['public']['Views']['user_onboarding_progress']['Row']
export type NotificationPreferenceUpdate = Database['public']['Tables']['notification_preferences']['Update']

export async function getNotifications(organizationId: string) {
  const { data, error } = await getSupabaseClient().from('notifications').select('*').eq('organization_id', organizationId).order('created_at', { ascending: false }).limit(100)
  if (error) throw error
  return data
}

export async function markNotificationRead(id: string, read: boolean) {
  const { error } = await getSupabaseClient().from('notifications').update({ read_at: read ? new Date().toISOString() : null }).eq('id', id)
  if (error) throw error
}

export async function markAllNotificationsRead(organizationId: string) {
  const { error } = await getSupabaseClient().rpc('mark_all_notifications_read', { target_organization_id: organizationId })
  if (error) throw error
}

export async function getNotificationPreferences(organizationId: string) {
  const { data, error } = await getSupabaseClient().from('notification_preferences').select('*').eq('organization_id', organizationId).single()
  if (error) throw error
  return data
}

export async function updateNotificationPreferences(organizationId: string, values: NotificationPreferenceUpdate) {
  const { error } = await getSupabaseClient().from('notification_preferences').update({ ...values, updated_at: new Date().toISOString() }).eq('organization_id', organizationId)
  if (error) throw error
}

export async function getOnboardingProgress(organizationId: string) {
  const { data, error } = await getSupabaseClient().from('user_onboarding_progress').select('*').eq('organization_id', organizationId).single()
  if (error) throw error
  return data
}

export async function updateOnboarding(organizationId: string, values: { welcome_seen_at?: string; dismissed_at?: string; completed_at?: string }) {
  const { error } = await getSupabaseClient().from('user_onboarding').update({ ...values, updated_at: new Date().toISOString() }).eq('organization_id', organizationId)
  if (error) throw error
}

export function unreadCount(notifications: Notification[]) { return notifications.filter((notification) => !notification.read_at).length }
